export default __webpack_public_path__ + "static/mini-helix-ps-scheda-tecnica-51ceb687f6b7829e95756b70cb79df70.pdf";